import { defineStore } from 'pinia';
import SharedBetslipError from '@/components/modals/SharedBetslipError.vue'
import { openModal } from "@kolirt/vue-modal";
import { BetSlip } from './BetSlip';

export const useSharedBetslipsStore = defineStore('shared_betslips', {
	state: () => ({
		//
	}),
	getters: {
		//
	},
	actions: {
		storeSharedBetslip(bets, type = null, betslip_id = null) {
			if (!type) type = BetSlip().betslip.type;
			let payload = { bets: bets, type: type, betslip_id: betslip_id }
			return global.axios.post(process.env.VUE_APP_API_URL + '/v2/betslip/share/store', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		},
		fetchSharedBetslip(code) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/v2/betslip/share/fetch', { code: code, id: true }).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		},
		deleteSharedBetslip(code, need_redirect) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/v2/betslip/share/delete', { code: code } ).then((response) => {

				if (need_redirect) openModal(SharedBetslipError, {delete: true, need_redirect: need_redirect}).catch(() =>{});
				else openModal(SharedBetslipError, {delete: true}).catch(() =>{});

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		}
	}
});
